import { Navigate, createBrowserRouter } from "react-router-dom";
import getRouterBasename from "@/utils/router";

import AuthCallback from "@/pages/AuthCallback";
import Element from "@/pages/Element";
import Env from "@/pages/Env";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Thread from "@/pages/Thread";
import Account from "@/pages/Account";
import NewAccount from "./pages/NewAccount";
// import GenerateReport from "@/pages/GenerateReport";
// import TokenUsage from "@/pages/dashboard/TokenUsage";
// import TokenCalculation from "@/pages/dashboard/TokenCalculation";
// import GeneralInformation from "./pages/dashboard/organization/GeneralInformation";
// import Member from "./pages/dashboard/organization/Member";
// import Project from "./pages/dashboard/organization/Project";
// import Billing from "./pages/dashboard/organization/Billing";
// import DBConnector from "./pages/dashboard/organization/DBConnector";
// import Profile from "./pages/dashboard/Profile";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/env",
      element: <Env />,
    },
    {
      path: "/thread/:id",
      element: <Thread />,
    },
    {
      path: "/element/:id",
      element: <Element />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    // {
    //   path: "/generate-report",
    //   element: <GenerateReport />,
    // },
    {
      path: "/login/callback",
      element: <AuthCallback />,
    },
    {
      path: "/list-account",
      element: <Account />,
    },
    {
      path: "/list-account/new",
      element: <NewAccount />,
    },
    {
      path: "/list-account/edit/:id",
      element: <NewAccount />,
    },

    // Dashboard routes
    // {
    //   path: "/dashboard/token-usage",
    //   element: <TokenUsage />,
    // },
    // {
    //   path: "/dashboard/token-calculation",
    //   element: <TokenCalculation />,
    // },

    // Dashboard Organization routes
    // {
    //   path: "/dashboard/organization/general-information",
    //   element: <GeneralInformation />,
    // },
    // {
    //   path: "/dashboard/organization/member",
    //   element: <Member />,
    // },
    // {
    //   path: "/dashboard/organization/db-connector",
    //   element: <DBConnector />,
    // },
    // {
    //   path: "/dashboard/organization/project",
    //   element: <Project />,
    // },
    // {
    //   path: "/dashboard/organization/billing",
    //   element: <Billing />,
    // },
    // {
    //   path: "/dashboard/profile",
    //   element: <Profile />,
    // },

    // catch all
    // {
    //   path: "/dashboard/*",
    //   element: <Navigate replace to="/dashboard/token-usage" />,
    // },
    {
      path: "*",
      element: <Navigate replace to="/list-account" />,
    },
  ],
  { basename: getRouterBasename() }
);
